// store/slices/reportSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Report } from '../../types';

interface ReportState {
  reports: Report[];
  currentReport: Report | null;
  reportData: any;
  loading: boolean;
  error: string | null;
}

const initialState: ReportState = {
  reports: [],
  currentReport: null,
  reportData: null,
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReports: (state, action: PayloadAction<Report[]>) => {
      state.reports = action.payload;
    },
    setCurrentReport: (state, action: PayloadAction<Report>) => {
      state.currentReport = action.payload;
    },
    setReportData: (state, action: PayloadAction<any>) => {
      state.reportData = action.payload;
    },
  },
});

export const { setReports, setCurrentReport, setReportData } = reportSlice.actions;
export default reportSlice.reducer;